import { Environment } from '@shared/interfaces/environment';
import { RoutesPath } from '@shared/enums/routes-path';
import { GlobalRoutesPath } from '@shared/enums/global-routes-path';
import { ServiceDetailRoutesPath } from '@car-read/pages/services/enums/service-detail-routes-path';

export const environment: Environment = {
  production: true,
  langs: {
    fr: {
      host: 'car-read.com',
      langs: ['fr', 'en', 'es'],
      defaultLang: 'fr',
      countryCode: ['fr'],
      plate: {
        code: 'f',
        placeholder: 'AB-123-CD',
      },
      api: {
        url: 'https://api.car-read.com',
      },
      google: {
        maps: {
          apiKey: 'AIzaSyD2fE0fYj7pcB_uCdY66T8co4PEZmVLe_4',
        },
      },
      sentry: {
        dsn: 'https://3c39b54c62c8a125974eebc34084f714@o4508637161783296.ingest.de.sentry.io/4508698653163600',
      },
      config: {
        name: 'Car-read',
        test: false,
        subscription: {
          name: 'Car-read+',
          prices: {
            fixed: 0.99,
            subscription: 49.99,
          },
          credit: 15,
        },
        advices: [
          {
            rate: 4.7,
            vote: 2254,
          },
        ],
        company: {
          rcs: '207787318',
          vat: 'BG207787318',
          address: 'Barzaritsa Street, 4A, ap.16, 1618 Sofia, Bulgaria',
          name: 'SRS MEDIA LTD',
        },
        partners: [],
        payment: {
          logo: '/assets/favicon.png',
        },
      },
      routes: {
        [RoutesPath.SIGN_IN]: 'connexion',
        [RoutesPath.SIGN_UP]: 'inscription',
        [RoutesPath.UNSUBSCRIBE]: 'resiliation',
        [RoutesPath.FORGOT_PASSWORD]: 'mot-de-passe-oublie',
        [RoutesPath.RESET_PASSWORD]: 'reset-password',
        [RoutesPath.CONTACT]: 'nous-contacter',
        [RoutesPath.SERVICES]: 'analyse-vehicule',
        [RoutesPath.ARTICLES]: 'blog-auto',
        [RoutesPath.LANDINGS]: 'landings/car-history',
        [RoutesPath.DASHBOARD]: 'mon-compte',
        [RoutesPath.NOT_FOUND]: 'erreur-404',
        [RoutesPath.ABOUT]: 'qui-sommes-nous',
        [RoutesPath.PREVIEW]: 'aperçu-rapport',
        [RoutesPath.PAYMENT_INTENT]: 'demande-paiement',
        [RoutesPath.PAYMENT_VALIDATION]: 'confirmation-paiement',
        [RoutesPath.LOADING]: 'chargement-en-cours',
        [RoutesPath.LOADING_PREVIEW]: 'aperçu-en-cours',
        [RoutesPath.PRICING]: 'tarifs-et-offres',
        [RoutesPath.SSO]: 'magiclogin',
        [RoutesPath.CAR_NOT_FOUND]: 'vehicule-introuvable',
        [RoutesPath.TESTIMONIALS]: 'avis-clients',
        [RoutesPath.SERVICE]: 'details-service',
        [RoutesPath.VIN]: 'decoder-vin',
        [RoutesPath.COMPARE]: 'comparer-nos-formules',
        [RoutesPath.PARTNERS]: 'nos-partenaires',
        [RoutesPath.GLOSSARY]: 'lexique-automobile',
        [RoutesPath.COMPANY]: 'notre-entreprise',
        [RoutesPath.AFFILIATE]: 'programme-affiliation',
        [RoutesPath.LEASING]: 'options-leasing',
        [RoutesPath.INSURANCE]: 'solutions-assurance',
        [RoutesPath.CAREERS]: 'recrutement',
        [RoutesPath.GUIDE]: 'guide-achat',
        [RoutesPath.PRESS]: 'espace-presse',
      },
      globalRoutes: {
        [GlobalRoutesPath.LEGAL_NOTICE]: 'mentions-legales',
        [GlobalRoutesPath.PRIVACY_POLICY]: 'politique-de-confidentialite',
        [GlobalRoutesPath.REFUND_POLICY]: 'politique-de-remboursement',
        [GlobalRoutesPath.TERMS_AND_CONDITIONS]: 'conditions-generales',
        [GlobalRoutesPath.TERMS_OF_SALES]: 'conditions-generales-de-vente',
        [GlobalRoutesPath.FREQUENTLY_ASKED_QUESTIONS]: 'faq',
      },
      serviceRoutes: {
        [ServiceDetailRoutesPath.BMW_DECODER]: 'bmw',
        [ServiceDetailRoutesPath.AUDI_DECODER]: 'audi',
        [ServiceDetailRoutesPath.VOLKSWAGEN_DECODER]: 'volkswagen',
        [ServiceDetailRoutesPath.RENAULT_DECODER]: 'renault',
        [ServiceDetailRoutesPath.PEUGEOT_DECODER]: 'peugeot',
        [ServiceDetailRoutesPath.CITROEN_DECODER]: 'citroen',
      },
      articleRoutes: {},
    },
  },
};
